module.exports = __webpack_public_path__ + "static/rain-a-5d082e27d8771cbac2ed0b6173f40e93.jpg";